module.exports = __webpack_public_path__ + "static/SFUIText-Bold-9817efee3d48c58758b3abb003989058.woff2";